// extracted by mini-css-extract-plugin
module.exports = {"map":"BackwardIcon_map__1cbTB","btn-backward":"BackwardIcon_btn-backward__1RE7l"};